import {useEffect} from 'react';

import Grid from '@mui/material/Grid';
import {bool} from 'prop-types';

import {REPORT_MODULES_CATEGORIES} from '../../../const';
import {useIsModuleVisibleOrEnabled} from '../../../hooks/components/report-modules/useIsModuleVisibleOrEnabled/useIsModuleVisibleOrEnabled';
import useMainSidebar from '../../../hooks/providers/useMainSidebar';
import PopperComponent from '../PopperComponent/PopperComponent';
import ReportModulesCategory from '../ReportModulesCategory/ReportModulesCategory';
import SingleReportCard from '../SingleReportCard/SingleReportCard';

const MoreReportsOrModulesPopper = ({isReportsPopper, showAllItems = false}) => {
  const {
    sidebarReports,
    isMoreReportsPopperOpen,
    setIsMoreReportsPopperOpen,
    moreReportsPopperAnchorEl,
    setMoreReportsPopperAnchorEl,
    setModuleCategoryExpanded: setCategoryExpanded,
    notVisibleSidebarModules,
    isMoreModulesPopperOpen,
    setIsMoreModulesPopperOpen,
    moreModulesPopperAnchorEl,
    setMoreModulesPopperAnchorEl,
    moreReportsOrModulesPopperRef
  } = useMainSidebar();
  const notVisibleReports = sidebarReports.filter(r => !r.is_visible);
  const reportsToDisplay = showAllItems ? sidebarReports : notVisibleReports;
  const {isModuleVisible} = useIsModuleVisibleOrEnabled();

  const allVisibleCategories = Object.values(REPORT_MODULES_CATEGORIES).filter(category => {
    const categoryHasVisibleModules = category.modules.some(m => isModuleVisible(m));
    return categoryHasVisibleModules;
  });

  const modulesToDisplay = showAllItems ? allVisibleCategories : notVisibleSidebarModules;

  const isPopperOpen = isReportsPopper ? isMoreReportsPopperOpen : isMoreModulesPopperOpen;
  const setIsPopperOpen = isReportsPopper ? setIsMoreReportsPopperOpen : setIsMoreModulesPopperOpen;
  const anchorEl = isReportsPopper ? moreReportsPopperAnchorEl : moreModulesPopperAnchorEl;
  const setPopperAnchorEl = isReportsPopper ? setMoreReportsPopperAnchorEl : setMoreModulesPopperAnchorEl;

  useEffect(() => {
    if (!isPopperOpen) {
      setCategoryExpanded(null);
    }
  }, [isPopperOpen]);

  return (
    <PopperComponent
      hasArrow={false}
      paperStyle={{ml: 5}}
      onClose={() => {
        setPopperAnchorEl(null);
        setIsPopperOpen(false);
      }}
      anchorEl={anchorEl}
      isOpen={isPopperOpen}
      ref={moreReportsOrModulesPopperRef}
    >
      <Grid
        container
        maxWidth={{
          xs: 195,
          sm: 260
        }}
      >
        {isReportsPopper
          ? reportsToDisplay.map(r => (
              <Grid item xs="auto" key={r.report_id}>
                <SingleReportCard isDisplayedInMoreReportsPopper report={r} />
              </Grid>
            ))
          : modulesToDisplay.map(category => <ReportModulesCategory isNestedInPopper key={category.id} category={category} />)}
      </Grid>
    </PopperComponent>
  );
};

MoreReportsOrModulesPopper.propTypes = {
  showAllItems: bool.isRequired,
  isReportsPopper: bool.isRequired
};

export default MoreReportsOrModulesPopper;
